import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { schedulerEndpoints } from '@/lib/api/endpoints';
import { schedulerKeys } from '@/lib/queryKeys';
import type { AppointmentCrewRole } from '@/types/jobAppointment';

/** GAP-02 — one upcoming assigned visit of a technician (offboarding sheet). */
export interface TechnicianUpcomingVisit {
  id: string;
  startAt: string | null;
  endAt: string | null;
  status: string;
  appointmentNumber: number | null;
  customerName: string;
  title: string;
  jobId: string | null;
  jobName: string | null;
  jobNumber: string | null;
  role: AppointmentCrewRole;
}

/**
 * GAP-02 — a technician's UPCOMING assigned visits (lead OR helper), for the
 * offboarding sheet. Backed by `GET /technicians/:id/appointments?upcoming=true`.
 */
export function useTechnicianUpcomingVisits(technicianId: string, enabled = true) {
  return useApiQuery<TechnicianUpcomingVisit[]>({
    queryKey: schedulerKeys.technicianUpcomingVisits(technicianId),
    queryFn: ({ signal }) =>
      apiGet<TechnicianUpcomingVisit[]>(
        operationsClient,
        `${schedulerEndpoints.technicianAppointments(technicianId)}?upcoming=true`,
        { signal },
      ),
    enabled: enabled && Boolean(technicianId),
    showErrorToast: false,
  });
}
